import { render } from "./AlignInvitation.vue?vue&type=template&id=56a90f99&scoped=true"
import script from "./AlignInvitation.vue?vue&type=script&lang=js"
export * from "./AlignInvitation.vue?vue&type=script&lang=js"

import "./AlignInvitation.vue?vue&type=style&index=0&id=56a90f99&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a90f99"]])

export default __exports__